import React from 'react'
import { withRouter } from 'react-router-dom'

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import { AuthContext } from '../../main/ProvedorAutenticacao'
import Navbar from '../../componentes/Navbar'

import UsuarioService from '../../app/service/UsuarioService'

class AlterarSenha extends React.Component {
  constructor(props) {
    super(props);

    this.usuarioService = new UsuarioService();

    this.state = {
      senhaUsuario: '',
      novaSenha: '',
      confirmacaoSenha: '',
    }
  }

  alterarSenha = () => {

    if(this.state.senhaUsuario == '') {
      this.toast.show({severity:'error', summary: 'Alterar Senha', detail:'Informe a senha de seu usuário', life: 4000});
      return;
    }

    if(this.state.novaSenha == '') {
      this.toast.show({severity:'error', summary: 'Alterar Senha', detail:'Informe a nova senha', life: 4000});
      return;
    }

    if(this.state.confirmacaoSenha == '') {
      this.toast.show({severity:'error', summary: 'Alterar Senha', detail:'Informe a confirmação de senha', life: 4000});
      return;
    }

    const usuarioLogado = this.context.usuarioAutenticado;

    const usuarioSenha = {
      codigo: usuarioLogado.codigo,
    };

    this.usuarioService.alterarSenha(this.state.senhaUsuario, this.state.novaSenha,this.state.confirmacaoSenha,usuarioSenha)
      .then(response => {
        this.limparCampos();
        this.toast.show({severity:'success', summary: 'Alterar Senha', detail:'Senha alterada com sucesso', life: 4000});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Alterar Senha', detail:`${this.state.detail}`, life: 4000});
      })
  };

  limparCampos = () => {
    this.setState({senhaUsuario: ''});
    this.setState({novaSenha: ''});
    this.setState({confirmacaoSenha: ''});
  }

  render() {
    return(
      <>
        <Navbar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
             <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fas fa-boxes"></i>
                        <span> Alterar Senha</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Password id="senhaUsuario" 
                                        size="60"
                                        type="text"
                                        autoComplete="nope"
                                        toggleMask="false"
                                        value={this.state.senhaUsuario}
                                        onChange={e => this.setState({senhaUsuario: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        placeholder="Senha Atual"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Password id="novaSenha" 
                                        size="60"
                                        autoComplete="nope"
                                        toggleMask
                                        value={this.state.novaSenha}
                                        onChange={e => this.setState({novaSenha: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        placeholder="Nova Senha"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Password id="confirmacao" 
                                        size="60"
                                        autoComplete="nope"
                                        value={this.state.confirmacaoSenha}
                                        toggleMask
                                        onChange={e => this.setState({confirmacaoSenha: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        placeholder="Confirmação nova senha"/>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="row">
                          <div className="col-sm-7">
                            <Button label="Alterar" 
                                    className="p-button-primary p-button-text"
                                    onClick={this.alterarSenha}/>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div> 
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    )
  }
}

AlterarSenha.contextType = AuthContext;
export default withRouter (AlterarSenha)